<template>
  <div class="user-avatar" :style="{ width: size + 'px', height: size + 'px' }">
    <img 
      v-if="src && !imageError" 
      :src="src" 
      :alt="alt" 
      class="avatar-image"
      @error="handleImageError"
    />
    <div v-else class="avatar-placeholder">
      <span class="avatar-initials">{{ initials }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppUserAvatar",
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: "User Avatar"
    },
    name: {
      type: String,
      default: "User"
    },
    size: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      imageError: false
    };
  },
  computed: {
    initials() {
      return this.name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('');
    }
  },
  methods: {
    handleImageError() {
      this.imageError = true;
    }
  }
};
</script>

<style scoped>
.user-avatar {
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #ffc107, #e0a800);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-initials {
  color: white;
  font-weight: 600;
  font-size: 0.8em;
  text-transform: uppercase;
}
</style>